<template>
  <div class="WidgetOptionsView">
    <div v-if="isAccessDenied && !is_list_loading">
      <div class="NoDataFound">
        <div class="text-center no-data-container">Access Denied</div>
      </div>
    </div>
    <div v-else>
      <WidgetNavbar style="position: fixed; top: 0; width: 100%; z-index: 5"></WidgetNavbar>

      <div class="pastRecoContainer">
        <div class="recoListSection">
          <div class="stock-data-section">
            <!-- <div class="bottom-margin-5 segment-radio-btn">
              <el-button
                size="mini"
                class="btn-theme-borderd custom-segment-btn"
                @click="
                  segment = 'Equity';
                  $router.push('/equity-insights');
                "
              >
                Equity
              </el-button>
              <el-button size="mini" class="btn-theme-filled cursor-disabled">
                Options
              </el-button>
            </div> -->
            <StrategyCard :recommendationsList="past_reco_track_list"></StrategyCard>
          </div>

          <div v-if="!is_list_loading && !past_reco_track_list.length">
            <div class="NoDataFound">
              <div class="text-center no-data-container">No data available</div>
            </div>
          </div>

          <div :class="{ 'infinite-loader-top-position': page_no == 1 }" v-if="is_list_loading">
            <div class="text-center">
              <img src="../../assets/images/company/loader.svg" style="height: 80px; width: 80px" />
            </div>
          </div>

          <div v-if="broker_data.broker_name == 'XTS'" class="text-center" style="color: #696969; margin: 10px 0px; font-weight: 600; margin-top: 20px; font-size: 17px">
            Visit
            <a href="https://stockants.com/login" target="__blank">www.stockants.com</a>
            for more
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { serverAddr } from '../../networkConfig';
import { screenSize } from '../../mixins/ScreenSize.js';
import { filterCallBack } from '../../mixins/filter';
import { HelperNetworkCallBack } from '../../mixins/Helper';
import { EventBus } from '../../eventBus';

import StrategyCard from '@/components/StockAntsLiteWidgets/WidgetStrategyCard.vue';
import WidgetNavbar from '@/components/StockAntsLiteWidgets/Navbar.vue';
import { WidgetHelperCallBack } from '../../mixins/WidgetCommonFunctions';

export default {
  name: 'PastStrategies',

  mixins: [filterCallBack, HelperNetworkCallBack, WidgetHelperCallBack, screenSize],

  components: {
    StrategyCard,
    WidgetNavbar,
  },

  data() {
    return {
      segment: 'Options',
      is_list_loading: true,
      past_reco_track_list: [],
      page_no: 1,
      searchObj: {},
      isAccessDenied: true,
    };
  },

  beforeRouteEnter(to, from, next) {
    if (to.query.broker_access_key) {
      localStorage.removeItem('widgetData');
    }
    setTimeout(() => {
      var searchObj = {
        stockSymbol: to.query.indice,
        broker_access_key: to.query.broker_access_key,
      };
      next((vm) => {
        vm.searchObj = searchObj;
      });
    }, 200);
  },
  watch: {
    searchObj: {
      handler(newValue) {
        if (newValue.broker_access_key && newValue.broker_access_key.length) {
          this.getBrokerDetails(newValue);
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (localStorage.getItem('widgetData')) {
      var widgetData = JSON.parse(localStorage.getItem('widgetData'));

      widgetData.timeStamp = new Date(widgetData.timeStamp);

      this.broker_data = widgetData;

      EventBus.$emit('updateBrokerData', this.broker_data);

      // get timeDifference in minute
      var timeDifference = Math.round((new Date().getTime() - widgetData.timeStamp.getTime()) / 1000) / 60;

      if (timeDifference < 360) {
        this.getAllPastRecoList(this.searchObj);
      } else {
        localStorage.removeItem('widgetData');
      }
    }
  },

  methods: {
    getBrokerDetails(stockDetails) {
      serverAddr
        .post('/auth/v1/widget_access_api', {
          access_key: stockDetails.broker_access_key,
        })
        .then((response) => {
          if (response.data.status) {
            response.data.data[0].timeStamp = new Date();
            this.broker_data = response.data.data[0];

            if (this.broker_data.width && this.broker_data.width.length) {
              this.broker_data.width = this.broker_data.width[0];
            }

            this.broker_data.broker_access_key = stockDetails.broker_access_key;
            this.getAllPastRecoList(stockDetails);
            EventBus.$emit('updateBrokerData', this.broker_data);

            localStorage.setItem('widgetData', JSON.stringify(response.data.data[0]));
          } else {
            this.isAccessDenied = true;
            this.is_list_loading = false;
          }
        })
        .catch(
          function (error) {
            this.isAccessDenied = true;
            this.is_list_loading = false;
            localStorage.removeItem('widgetData');
            console.log(error);
          }.bind(this)
        );
    },
    getAllPastRecoList(stockDetails) {
      this.isAccessDenied = false;
      this.is_list_loading = true;

      var obj = {
        page_no: 1,
        page_per_entries: 2,
      };

      // this.broker_data.broker_name == 'XTS' ? obj.page_per_entries = 2 : obj.page_per_entries = 3

      if (stockDetails) {
        obj.symbol = stockDetails.stockSymbol;
      }
      serverAddr
        .post(`/options/open_api/opinion/market/${this.broker_data.broker_access_key}`, obj)
        .then((response) => {
          if (response.data.status) {
            this.is_list_loading = false;

            response.data.data.forEach((element, index) => {
              // created new key toggle_more_info in response for toggle more info section
              this.$set(element, 'toggle_more_info', false);
              this.$set(element, 'expert_list', []);
              this.$set(element, 'closed_reco_list', []);
              this.$set(element, 'closed_reco_list_loading', false);
              this.$set(element, 'is_loading', false);
              this.$set(element, 'compared_experts_list', []);
              if (element.created_at != null && element.stock.today != null) {
                //calculate difference between today & created date
                //if reco is closed then sent closed day
                //if target is achieved then send target achieved date
                //if target is not achieved and accuracy is out then send result_date_time

                let start_date = element.created_at;

                element.reco_status == 'STOP LOSS TRIGGERED' || element.reco_status == 'TARGET NOT ACHIEVED';

                let end_date = element.reco_status == 'TARGET ACHIEVED' ? element.target_achieved_date_time : element.reco_status == 'TARGET NOT ACHIEVED' ? element.target_not_achieved_date_time : element.reco_status == 'STOP LOSS TRIGGERED' ? element.stop_loss_triggered_date_time : element.stock.today;

                element.difference_in_days = this.getDifferenceBetweenTwoDays(start_date, end_date);

                // this.openTradeWidget(element.stock.symbol, element.id);
              } else {
                element.difference_in_days = 0;
              }

              this.past_reco_track_list.push(response.data.data[index]);
            });

            // this.scrollToTop();     //scroll to top of list
          } else {
            this.is_list_loading = false;
            this.past_reco_track_list = [];
          }
        })
        .catch(
          function (error) {
            console.log(error);
            this.is_list_loading = false;
          }.bind(this)
        );
    },
  },

  beforeDestroy() {
    EventBus.$off();
  },
};
</script>

<style lang="scss" scoped>
@import '../../css/variable.scss';
@import '../../css/common.scss';

.WidgetOptionsView {
  background-color: $page-background-color;
  padding: 0;
  padding-top: 65px;
  height: 100vh;
  overflow-y: auto;
}

/* width */
.WidgetOptionsView::-webkit-scrollbar {
  width: 1px;
}

/* Track */
.WidgetOptionsView::-webkit-scrollbar-track {
  background: #f3f3f3;
}

/* Handle */
.WidgetOptionsView::-webkit-scrollbar-thumb {
  background: #f3f3f3;
}

.WidgetOptionsView .search-container {
  box-sizing: border-box;
  position: fixed;
  width: calc(100% - 285px);
  margin-left: 285px;
  padding: 0px 10px 10px 10px;
  z-index: 2;
}

.WidgetOptionsView .search-stock-section {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  background-color: $page-background-color;
  padding: 15px 0px;
  width: 100%;
}

.WidgetOptionsView .recoListSection {
  box-sizing: border-box;
  width: 100%;
  padding: 0 10px;
  min-height: 100vh;
}

.WidgetOptionsView .footer-section {
  width: calc(100% - 285px);
  margin-left: 285px;
}

//media queries
@media screen and (max-width: 1283px) {
  .WidgetOptionsView {
    padding: 135px 0 80px 0;
  }

  .WidgetOptionsView .recoListSection {
    width: 100%;
    margin-left: 0;
  }

  .WidgetOptionsView .footer-section {
    width: 100%;
    margin-left: 0;
  }

  .WidgetOptionsView .search-container {
    width: 100%;
    margin-left: 0;
    padding: 0;
  }

  .WidgetOptionsView .search-stock-section {
    display: block;
    padding: 20px 10px 10px 10px;
  }

  .WidgetOptionsView .stock-data-section {
    padding: 10px 0px 0;
  }

  .WidgetOptionsView .action-btn-component {
    display: flex;
    justify-content: center;
    margin: 10px 0;
  }

  .desktopFilterSection {
    display: none;
  }
}

//media queries
@media screen and (max-width: 700px) {
  .WidgetOptionsView {
    padding: 125px 0 80px 0;
  }
}
</style>

<style lang="scss">
@import '../../css/variable.scss';
@import '../../css/common.scss';

.NoDataFound {
  padding: 150px 0 0 0;
}

.no-data-container {
  max-width: 300px;
  border: 1px solid $secondary-theme-color;
  padding: 8px;
  margin: 50px auto;
  color: $secondary-theme-color;
  font-size: 13px;
  font-weight: 300;
  border-radius: 6px;
}

.WidgetOptionsView .update-reco-card {
  box-shadow: none;
}

.WidgetOptionsView .rupees-symbol {
  position: absolute;
  top: 7px;
  left: 15px;
  z-index: 1;
  font-size: 0.9rem;
  color: black;
  font-weight: bold;
}

.WidgetOptionsView .percentSymbol {
  position: absolute;
  top: 5px;
  right: 80px;
  z-index: 1;
  color: #606266;
}

.WidgetOptionsView .unlocked-antestimate-notifybar {
  cursor: pointer;
  color: black;
  font-weight: 800;
  width: 100%;
  box-sizing: border-box;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  opacity: 1;
  display: flex;
  transition: opacity 0.2s;
  font-size: 1.2rem;
}

.WidgetOptionsView .selection-tag {
  font-size: 0.7rem;
  height: 25px;
  line-height: 24px;
}

.WidgetOptionsView .stock-details-section {
  display: flex;
  align-items: center;
}

.WidgetOptionsView .stock-title {
  max-width: 300px;
}

.WidgetOptionsView .current-price {
  font-size: 1.2rem;
  font-weight: 600;
  color: #000;
}

.WidgetOptionsView .border-bottom-gray {
  border-bottom: 1px solid #ddd;
  padding-bottom: 10px;
}

.WidgetOptionsView .cross-icon {
  color: #ddd;
  font-size: 20px;
  cursor: pointer;
}

.WidgetOptionsView .cross-icon:hover {
  font-size: 20px;
  color: #000;
}

.WidgetOptionsView .el-select-dropdown__item {
  color: #000 !important;
  font-weight: 300 !important;
}

.WidgetOptionsView .target-price-input {
  width: 100%;
}

.WidgetOptionsView .sector-dropdown .el-input__inner {
  border-radius: 12px;
  height: 20px;
  border-radius: 10px;
  font-size: 0.6rem;
  text-transform: uppercase;
  font-weight: 500;
  color: #000;
}

.WidgetOptionsView .target-price-input-section .el-input__inner::placeholder {
  font-size: 0.8rem;
  font-weight: 500;
}

.WidgetOptionsView .el-select .el-input .el-select__caret.is-reverse {
  position: absolute;
  top: -4px;
  right: 0;
}

.WidgetOptionsView .sector-dropdown .el-select__caret {
  position: absolute;
  top: 3px;
  right: 0;
}

.WidgetOptionsView .sector-dropdown .el-select__caret {
  font-size: 13px;
}

.WidgetOptionsView .target-price-input .el-input__inner {
  border-radius: 25px;
}

.WidgetOptionsView .target-price-input .el-input-number__increase,
.WidgetOptionsView .target-price-input .el-input-number__decrease {
  line-height: 0;
  border-radius: 50px;
  width: 22px;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  border: none;
  background-color: $secondary-theme-color;
  border-color: $secondary-theme-color;
  color: #fff;
  display: none;
}

.WidgetOptionsView .target-price-input .el-input-number__decrease {
  right: 35px;
  top: 5px;
}

.WidgetOptionsView .target-price-input .el-input-number__increase {
  right: 5px;
  top: 5px;
}

.WidgetOptionsView .target-price-input-section .el-input__inner {
  text-align: left;
  // height: 35px;
  padding-left: 30px;
  color: black;
  font-weight: 600;
  font-size: 0.9rem;
}

.WidgetOptionsView .potential-return-value {
  font-size: 0.7rem;
  font-weight: 600;
  position: absolute;
  top: 8px;
  right: 8px;
  // right: 30%;
  z-index: 1;
  color: #979797;
}

.WidgetOptionsView .inactive-period-type-tag {
  text-align: center;
  border-radius: 12px;
  padding: 0 10px;
  margin: 0 0.3rem 0 0;
  background-color: #fff;
  border-color: #d9d9d9;
  font-weight: 600;
  color: #878787;
  min-width: 50px;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 10px;
}

.WidgetOptionsView .disabled-period-type-tag {
  margin-right: 0.3rem;
  border-radius: 12px;
  padding: 0 10px;
  min-width: 50px;
  font-weight: 600;
  text-align: center;
  border-color: #ddd;
  background-color: #ddd;
  color: #fff;
  text-transform: uppercase;
  font-size: 10px;
  cursor: not-allowed;
}

.WidgetOptionsView .active-period-type {
  margin-right: 0.3rem;
  border-radius: 12px;
  padding: 0 10px;
  min-width: 50px;
  font-weight: 600;
  text-align: center;
  border-color: $secondary-theme-color;
  background-color: $secondary-theme-color;
  color: #fff;
  text-transform: uppercase;
  font-size: 10px;
}

.WidgetOptionsView .active-period-type:focus,
.WidgetOptionsView .inactive-period-type-tag:focus {
  outline: none;
}

.WidgetOptionsView .el-button.is-disabled.is-plain {
  border-radius: 61px;
}

.WidgetOptionsView .el-button.is-disabled.is-plain {
  background-color: #eee;
}

.WidgetOptionsView .info-Logo {
  height: 9px;
  padding: 0px 2px 0px 3px;
}

.WidgetOptionsView .NoDataFound {
  padding: 60px 0 0 0;
}

.WidgetOptionsView .quarter-tag {
  // width: 170px;
  input {
    border-radius: 25px;
    // height: 25px;
  }

  input::placeholder {
    // color: $primary-theme-color;
    // font-size: 10px;
    font-weight: 500;
  }
}

.WidgetOptionsView .active-quarter {
  input {
    background-color: $secondary-theme-color;
    border-color: $secondary-theme-color;
    color: #fff;
  }

  .el-select__caret {
    color: #fff;
  }
}

.WidgetOptionsView .upload-btn {
  background: #d5d3e0;
  color: #000;
  padding: 5px 15px;
  border-radius: 50px;
  font-size: 0.7rem;
  font-weight: 500;
  width: fit-content;
  cursor: pointer;
}

.reco-update-dialog {
  width: 60%;
}

.segment-radio-btn {
  display: flex;
  justify-content: end;
  margin-right: 10px;
  // .el-radio__input.is-disabled .el-radio__inner,
  // .el-radio__input.is-disabled.is-checked .el-radio__inner {
  //   background-color: #fb0010;
  //   border-color: #e72726;
  // }

  // .el-radio__input.is-disabled + span.el-radio__label {
  //   color: #606266;
  // }
  .custom-segment-btn {
    border: none;
    color: #3b3b3b;
  }
}

@media screen and (max-width: 650px) {
  .reco-update-dialog {
    width: 90%;
  }
}
</style>
